import { Button, Grid } from '@mui/material';
import { Save01 } from '../../../assets';
import { useContext } from 'react';
import { StockCountZonesContext, StockCountZonesContextValues } from '../contexts/StockCountZonesContext';
import PageTitle from '../../../components/shared/PageTitle';
import BackButton from '../../../components/shared/actions/BackButton';

const CountZonesTop = () => {
  const {
    t,
    zoneName,
    selectedStores,
    handleLeaveClick,
    submitCountZone,
    isSubmitting,
    isCreating,
  } = useContext(StockCountZonesContext) as StockCountZonesContextValues;

  return (
    <Grid container>
      <Grid item
        xs={12}>
        <BackButton
          handleClick={handleLeaveClick}
          title={t('back')}
          isLink={false}
        />
      </Grid>
      <Grid item
        xs={12}
        sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' }}>
        <Grid item
          sx={{ marginRight: '20px' }}>
          <PageTitle>{isCreating ? t('createTitle') : t('editTitle')}</PageTitle>
        </Grid>
        <Button
          size='lg'
          disabled={
            !zoneName?.trim() ||
                        selectedStores.length === 0 ||
                        isSubmitting
          }
          onClick={submitCountZone}
        >
          {isCreating ? <><Save01 />{t('create')}</> : <><Save01 />{t('save')}</>}
        </Button>

      </Grid>
    </Grid>
  );
};

export default CountZonesTop;